/* eslint-disable camelcase */
import * as THREE from 'three'
import { getGeometryArray } from '../getGeometryArray'

export const drawRect = (group, options) => {
  const {
    color,
    borderColor,
    position,
    scale,
    opacity = 1,
    sceneMeshes
  } = options
  const { height, width } = group

  const geometry = new THREE.PlaneGeometry(width * scale, height * scale)
  const material = new THREE.MeshBasicMaterial({
    color,
    opacity,
    transparent: true
  })
  const rect = new THREE.Mesh(geometry, material)

  if (borderColor) {
    const lineBasicMaterial = new THREE.LineBasicMaterial({
      color: borderColor
    })
    const lineGeometry = new THREE.BufferGeometry()
    const geometryArray = getGeometryArray(geometry)
    const vertices = new Float32Array(geometryArray)

    geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3))
    const line = new THREE.Line(lineGeometry, lineBasicMaterial)
    rect.add(line)
  }

  rect.position.set(position.x, position.y, position.z)

  const triangle = new THREE.Group()
  triangle.add(rect)
  triangle.obj = rect
  sceneMeshes.push(triangle)

  return [triangle]
}
